<template>
  <div class="add-advertising-format">
    <div class="base-cell">
      <div class="lable">广告格式：</div>
      <div class="value">{{ forms.adFormat == 0 ? "商品集" : "视频"}}</div>
    </div>
    <div class="base-cell">
      <div class="lable">着陆页：</div>
      <a :href="detailsData.landingPageVo && detailsData.landingPageVo.url" target="_blank"  style="color: #1F6EEF;">{{ forms.adFormat == 0 ? "新商品列表页" : "商品详情页"}}</a>
    </div>
    <!-- <div class="table-cell">
      <gj-table
        :index="false"
        :adapt-height="false"
        :height="316"
        :data="[]"
        stripe
        :columns="columns">
      </gj-table>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'add-advertising-format',
  inject: ['getForms', 'getDetailsData'],
  props: {},
  data() {
    return {
      forms: {},
      columns: [
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px'},
          {id: 'listingTitle', header: '商品信息',field: 'slot:listingTitle', minWidth: '180px'},
          // {id: 'op', header: 'slot:op',field: 'slot:op', width: '100'},
        ],
    };
  },
  components: {
  },
  computed: {
    detailsData() {
      return this.getDetailsData()
    }
  },
  methods: {},
  created() {
    let { addAdvertisingFormat } = this.getForms()
    this.forms = addAdvertisingFormat
  },
};
</script>

<style scoped lang='scss'>
.add-advertising-format {
  .base-cell {
    display: flex;
    font-size: 12px;
    padding-bottom: 15px;
    .lable {
      width: 80px;
      text-align: right;
      color: #666;
    }
    .value {
      padding-left: 15px;
      color: #333;
    }
  }
  .table-cell {
    border: 1px solid #eee;
    margin-left: 95px;
    width: 1100px;
  }
  /deep/.gj-empty {
    width: 170px;
  }
  /deep/.vxe-cell--title {
    span {
      font-weight: 500;
    }
  }
}
</style>